export default __webpack_public_path__ + "static/media/banner-9.85f69fff.jpg";